import { ADMIN_METAS_LIST } from './index';
import { Action } from '../action';
import { AccessCodeServiceCustomFields } from '@shared/core';

export class AdminMetasListInitAction implements Action {
	readonly type = ADMIN_METAS_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListDestroyAction implements Action {
	readonly type = ADMIN_METAS_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListHydrateAction implements Action {
	readonly type = ADMIN_METAS_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListHydrateSuccessAction implements Action {
	readonly type = ADMIN_METAS_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: AccessCodeServiceCustomFields[],
		public correlationId?: number
	) {}
}

export class AdminMetasListHydrateFailureAction implements Action {
	readonly type = ADMIN_METAS_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminMetasListDeleteAction implements Action {
	readonly type = ADMIN_METAS_LIST.DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListDeleteSuccessAction implements Action {
	readonly type = ADMIN_METAS_LIST.DELETE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListDeleteFailureAction implements Action {
	readonly type = ADMIN_METAS_LIST.DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminMetasListClickAddAction implements Action {
	readonly type = ADMIN_METAS_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListClickEditAction implements Action {
	readonly type = ADMIN_METAS_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListClickDeleteAction implements Action {
	readonly type = ADMIN_METAS_LIST.CLICK_DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListSelectAction implements Action {
	readonly type = ADMIN_METAS_LIST.SELECT;
	constructor(
		public payload: AccessCodeServiceCustomFields,
		public correlationId?: number
	) {}
}

export class AdminMetasListSelectOrganizationGroupAction implements Action {
	readonly type = ADMIN_METAS_LIST.SELECT_ORGANIZATION_GROUP;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminMetasListSelectOrganizationAction implements Action {
	readonly type = ADMIN_METAS_LIST.SELECT_ORGANIZATION;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminMetasListClickOrganizationBacklinkAction implements Action {
	readonly type = ADMIN_METAS_LIST.CLICK_ORGANIZATION_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasListClickGroupBacklinkAction implements Action {
	readonly type = ADMIN_METAS_LIST.CLICK_GROUP_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
